var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{staticClass:"activity-video",attrs:{"data-activity-asset":""}},[_c('div',{staticClass:"activity-video__element"},[_c('AssetVideo',{key:_vm.videoSrc,ref:"video",attrs:{"id":_vm.data[0].id,"src":_vm.isOnline ? _vm.videoSrc : _vm.findPreloadedAsset('video', _vm.videoSrc),"muted":true,"loop":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }